export default __webpack_public_path__ + "static/media/000_wurz.6a1e2eeb.png";